import { CommonModule } from '@angular/common';
import { Component, inject, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { DividerModule } from 'primeng/divider';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { UserService } from '@services/user.service';
import { SessionService } from '@utils/session.service';
import { UtilsService } from '@utils/utils.service';
import { ToastService } from '@utils/toast.service';
import { DrawerModule } from 'primeng/drawer';

@Component({
  selector: 'app-create-pricing-group',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    InputMaskModule,
    PasswordModule,
    ButtonModule,
    MultiSelectModule,
    InputNumberModule,
    SelectModule,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    TabViewModule,
    FieldsetModule,
    DrawerModule,
  ],
  templateUrl: './create-pricing-group.component.html',
  styleUrl: './create-pricing-group.component.scss',
})
export class CreatePricingGroupComponent {
  @Output() saved = new EventEmitter<void>();
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private utils = inject(UtilsService);
  private sessionService = inject(SessionService);
  private toastService = inject(ToastService);

  public Object = Object;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  public isSaving = false;
  public listUsers: any[] = [];

  public form = this.formBuilder.group({
    NAME: [null, Validators.required],
    USERS: [null, Validators.required],
    PRICES: this.formBuilder.group({
      REGISTRO_CIVIL: this.formBuilder.group({
        DIGITALIZACION: [1, Validators.required],
        CORRECCION_ACTA: [1, Validators.required],
        MARCO_FOLIO_REVERSO: [1, Validators.required],
        BUSCAR_ACTO: this.formBuilder.group({
          AGUASCALIENTES: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          BAJA_CALIFORNIA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          BAJA_CALIFORNIA_SUR: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CAMPECHE: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          COAHUILA_DE_ZARAGOZA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          COLIMA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CHIAPAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CHIHUAHUA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          CIUDAD_DE_MEXICO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          DURANGO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          GUANAJUATO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          GUERRERO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          HIDALGO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          JALISCO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MEXICO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MICHOACAN_DE_OCAMPO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          MORELOS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          NAYARIT: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          NUEVO_LEON: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          OAXACA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          PUEBLA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          QUERETARO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          QUINTANA_ROO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SAN_LUIS_POTOSI: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SINALOA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          SONORA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TABASCO: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TAMAULIPAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          TLAXCALA: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          VERACRUZ: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          YUCATAN: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
          ZACATECAS: this.formBuilder.group({
            NACIMIENTO: [1, Validators.required],
            MATRIMONIO: [1, Validators.required],
            DEFUNCION: [1, Validators.required],
            DIVORCIO: [1, Validators.required],
          }),
        }),
      }),
      SAT: this.formBuilder.group({
        CAMBIO_EMISION: [1, Validators.required],
        CEDULA_IDENTIFICACION_FISCAL: [1, Validators.required],
        CITA_PERSONA_FISICA: [1, Validators.required],
        CONSTANCIA_SITUACION_FISCAL: [1, Validators.required],
        OPINION_CUMPLIMIENTO: [1, Validators.required],
        RECUPERACION_CFDI: [1, Validators.required],
        RECUPERACION_DECLARACION: [1, Validators.required],
        CITA_PERSONA_MORAL: [1, Validators.required],
        ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA: [1, Validators.required],
        ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA: [1, Validators.required],
        CONTRASENA_CIEC_INE: [1, Validators.required],
      }),
      IMSS: this.formBuilder.group({
        INFORMACION_NSS: [1, Validators.required],
        CONSULTAR_NSS: [1, Validators.required],
        ASIGNAR_CORREO_NSS: [1, Validators.required],
        SEMANAS_COTIZADAS: [1, Validators.required],
        VIGENCIA_DERECHO: [1, Validators.required],
        NO_DERECHOHABIENTE: [1, Validators.required],
      }),
      RENAPO: this.formBuilder.group({
        CURP: [1, Validators.required],
        CORRECCION_CURP: [1, Validators.required],
        UNIFICACION_CURP: [1, Validators.required],
        CERTIFICACION_CURP: [1, Validators.required],
      }),
      ISSSTE: this.formBuilder.group({
        TALON_PAGOS: [1, Validators.required],
        CONSTANCIA_ACREDITACION_NO_AFILIACION: [1, Validators.required],
      }),
    }),
  });

  private initialFormValues: any;

  public ngOnInit() {
    this.initialFormValues = this.form.getRawValue();

    let userId = this.sessionService.getUser()?.userId;

    this.userService.getUsersOfUser(Number(userId)).then((response: any) => {
      this.listUsers = response.childrens.map((user: any) => ({ label: user.nickname, value: user.userId }));

      this.listUsers = this.utils.orderArrayBy(this.listUsers, 'label');
    });
  }

  formatEstadoName(estado: string): string {
    const estadosMap: { [key: string]: string } = {
      AGUASCALIENTES: 'Aguascalientes',
      BAJA_CALIFORNIA: 'Baja California',
      BAJA_CALIFORNIA_SUR: 'Baja California Sur',
      CAMPECHE: 'Campeche',
      COAHUILA_DE_ZARAGOZA: 'Coahuila',
      COLIMA: 'Colima',
      CHIAPAS: 'Chiapas',
      CHIHUAHUA: 'Chihuahua',
      CIUDAD_DE_MEXICO: 'Ciudad de México',
      DURANGO: 'Durango',
      GUANAJUATO: 'Guanajuato',
      GUERRERO: 'Guerrero',
      HIDALGO: 'Hidalgo',
      JALISCO: 'Jalisco',
      MEXICO: 'México',
      MICHOACAN_DE_OCAMPO: 'Michoacán',
      MORELOS: 'Morelos',
      NAYARIT: 'Nayarit',
      NUEVO_LEON: 'Nuevo León',
      OAXACA: 'Oaxaca',
      PUEBLA: 'Puebla',
      QUERETARO: 'Querétaro',
      QUINTANA_ROO: 'Quintana Roo',
      SAN_LUIS_POTOSI: 'San Luis Potosí',
      SINALOA: 'Sinaloa',
      SONORA: 'Sonora',
      TABASCO: 'Tabasco',
      TAMAULIPAS: 'Tamaulipas',
      TLAXCALA: 'Tlaxcala',
      VERACRUZ: 'Veracruz',
      YUCATAN: 'Yucatán',
      ZACATECAS: 'Zacatecas',
    };

    return estadosMap[estado] || estado;
  }

  createPricingGroup(): void {
    this.isSaving = true;

    this.userService
      .createPricingGroup(this.form.value)
      .then((response: any) => {
        this.toastService.success('Se creo el grupo de precios.');
        this.saved.emit();
        this.closeDrawer();
      })
      .catch((error: any) => {
        this.toastService.error(error.message || 'Ocurrió un error al crear el grupo de precios.');
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  public closeDrawer(): void {
    this.form.reset(this.initialFormValues);
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
